<script lang="ts" setup>
/* eslint-disable vue/no-v-html */
export interface PagesAboutProfileRating {
    title: string
    description: string
}
export interface PagesAboutProfileRatingsProps {
    data: PagesAboutProfileRating[]
}

const props = defineProps<PagesAboutProfileRatingsProps>()
const { $formatTableHtml } = useNuxtApp()
</script>
<template>
  <ScrollSection class="g-6">
    <ScrollSectionItem
      v-for="(rating, index) in props.data"
      :key="`rating-${index}`"
      class="col-10 col-md-6 col-lg-3"
    >
      <article
        class="py-10 px-4 rounded text-center box-shadow-1 bg-white h-100"
      >
        <span class="alfa d-block text-secondary mb-4">
          {{ rating.title }}
        </span>
        <div
          class="text-black"
          v-html="$formatTableHtml(rating.description)"
        />
      </article>
    </ScrollSectionItem>
  </ScrollSection>
</template>
